import { ITokenStrategy } from "@/interfaces/ITokenStrategy";
import { getAuthTokenFromLocalStorage, isUserLoggedIn } from '@/utils/utils';
import log from 'loglevel';

class TokenRequiredStrategyClass implements ITokenStrategy {
    appendTokenToParams(params?: any) {
        // Check if user is logged in
        if (!isUserLoggedIn()) {
            throw new Error('User is not authenticated. API call prevented.');
        }
        
        const authToken = getAuthTokenFromLocalStorage();
        
        // Basic validation of the token format
        if (!authToken || typeof authToken !== 'string' || authToken.trim() === '') {
            log.error('Invalid auth token format detected');
            throw new Error('User is not authenticated. API call prevented.');
        }
        
        return { ...params, auth_token: authToken };
    }
}

const TokenRequiredStrategy = new TokenRequiredStrategyClass();
export { TokenRequiredStrategy };
